import { NgModule } from '@angular/core';

import { FilterCollectionPipe } from './filter-collection.pipe';

@NgModule({
  declarations: [FilterCollectionPipe],
  exports: [FilterCollectionPipe],
})
export class SharedPipesModule {}
